import { Head, Link, usePage } from "@inertiajs/react";
import AuthLayout from "@/layouts/auth-layout";
import { manage_products_path, product_path } from "@/routes";

function Index({ products }) {
  const { current_user: currentUser } = usePage().props;

  return (
    <>
      <Head title="Produkter" />

      <section className="workspace-content">
        <div className="row g-4">
          <div className="col-12">
            <div className="card workspace-hero h-100">
              <div className="card-body">
                <div className="workspace-hero__badge">
                  Produktoversigt
                </div>
                <h2 className="workspace-hero__title">
                  Tilgængelige produkter i arbejdsrummet
                </h2>
                <p className="workspace-hero__copy mb-0">
                  Se de produkter, som er gjort tilgængelige for den aktive organisation, og gå videre til trin, dokumenter og implementeringsforløb.
                </p>
              </div>
            </div>
          </div>

          {products.length === 0 ? (
            <div className="col-12">
              <div className="workspace-empty">
                <h3 className="workspace-empty__title">Ingen produkter endnu</h3>
                <p className="workspace-empty__copy">
                  Start med at oprette jeres første produkt til efterlevelse i dette arbejdsrum.
                </p>
                {currentUser?.super_admin ? (
                  <Link href={manage_products_path()} className="btn btn-primary mt-3">
                    Administrer produkter
                  </Link>
                ) : null}
              </div>
            </div>
          ) : (
            products.map((product) => (
              <div key={product.id} className="col-12">
                <article className="card h-100">
                  <div className="card-body workspace-card-stack">
                    <div className="d-flex align-items-start justify-content-between gap-4">
                      <div>
                        <div className="workspace-card-eyebrow">{product.tag}</div>
                        <h3 className="workspace-card-title">{product.name}</h3>
                      </div>
                    </div>

                    <p className="workspace-card-description">
                      {product.description || "Et struktureret arbejdsrum til efterlevelse med ordnede trin, understøttende politikker, implementeringsguides og dokumenter."}
                    </p>

                    <div className="d-flex flex-wrap gap-3">
                      <span className="workspace-chip">{product.steps_count} trin</span>
                      <span className="workspace-chip">
                        {product.templates_count} {product.templates_count === 1 ? "dokument" : "dokumenter"}
                      </span>
                    </div>

                    <div className="workspace-product-progress workspace-product-progress--index" aria-label="Dokumentfremdrift">
                      <div className="workspace-product-progress__header">
                        <span>Dokumenter udfyldt</span>
                        <strong>
                          {product.template_progress?.completed || 0} af {product.template_progress?.total || 0}
                        </strong>
                      </div>
                      <div className="workspace-product-progress__track" aria-hidden="true">
                        <div
                          className="workspace-product-progress__bar"
                          style={{ width: `${product.template_progress?.total === 0 ? 100 : product.template_progress?.percentage || 0}%` }}
                        />
                      </div>
                    </div>

                    <div className="workspace-card-stack__footer">
                      <Link href={product_path(product.id)} className="btn btn-primary">
                        Se produkt
                      </Link>
                    </div>
                  </div>
                </article>
              </div>
            ))
          )}
        </div>
      </section>
    </>
  );
}

Index.layout = (page) => {
  const { current_user: currentUser, layout_header: layoutHeader } = page.props;

  return (
    <AuthLayout
      header={{
        breadcrumbs: [{ label: layoutHeader?.breadcrumb || "Produkter" }],
        title: layoutHeader?.title || "Struktureret efterlevelsesforløb",
        actions: currentUser?.super_admin ? [
          {
            href: manage_products_path(),
            label: "Administrer",
            variant: "primary"
          }
        ] : []
      }}
    >
      {page}
    </AuthLayout>
  );
};

export default Index;
